import { IQuestionAboutAutoparts } from "api/interfaces/static-pages/question-about-autoparts.type";
import FaqsContainer from "./questions-about-autoparts/FaqsContainer";

function FAQs(props: IQuestionAboutAutoparts) {
  return <FaqsContainer {...props} />;
}
export default FAQs;
